import { AfterViewInit, Directive, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { AutoComplete } from 'primeng/autocomplete';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';

@Directive({
  selector: '[fpLocale], p-autoComplete',
  standalone: false,
})
export class AutoCompleteLocaleDirective implements OnInit, AfterViewInit, OnDestroy {
  private destroy$ = new Subject<void>();
  private observer?: MutationObserver;

  constructor(
    private autoComplete: AutoComplete,
    private translate: TranslateService,
    private host: ElementRef<HTMLElement>
  ) {}

  ngOnInit() {
    this.updateEmptyMessage();

    this.translate.onLangChange.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.updateEmptyMessage();
      queueMicrotask(() => this.restorePlaceholder());
    });
  }

  ngAfterViewInit() {
    this.restorePlaceholder();
    this.observer = new MutationObserver(() => this.restorePlaceholder());
    this.observer.observe(this.host.nativeElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['placeholder'],
    });
  }

  updateEmptyMessage() {
    this.translate.get('PRIMENG.emptyMessage').subscribe(message => {
      this.autoComplete.emptyMessage = message;
    });
  }

  ngOnDestroy() {
    this.observer?.disconnect();
    this.destroy$.next();
    this.destroy$.complete();
  }

  // PrimeNG 20 only puts placeholder on the inner input when the control is empty.
  // Restore the v17 behavior so "type to add" remains visible next to selected chips.
  private restorePlaceholder() {
    const placeholder = this.autoComplete.placeholder;
    if (!placeholder) {
      return;
    }
    const input = this.host.nativeElement.querySelector('input');
    if (input && input.getAttribute('placeholder') !== placeholder) {
      input.setAttribute('placeholder', placeholder);
    }
  }
}
